module.exports = __webpack_public_path__ + "static/media/groupstar_big.c6572a70.png";